module.exports = __webpack_public_path__ + "static/media/OKLogoVer5.7968f37c.png";